import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useEffect, useRef, useState } from "react";
import "../assets/css/adminHeader.css";

export default function DashboardHeader({ onToggleSidebar, sidebarOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const [openMenu, setOpenMenu] = useState(null);
  const headerRef = useRef(null);

  const initials =
    `${user?.first_name?.[0] || ""}${user?.last_name?.[0] || ""}`.toUpperCase();
const isAdminDashboard =
  location.pathname.includes("/dashboard/admin");

const title = isAdminDashboard
  ? "Admin Dashboard"
  : "HRM / CRM";

  /* CLOSE DROPDOWN ON OUTSIDE CLICK */
  useEffect(() => {
    const handler = (e) => {
      if (headerRef.current && !headerRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <>
      {/* ================= SIDEBAR OVERLAY ================= */}
      {sidebarOpen && (
        <div
          className="dashboard-overlay"
          onClick={onToggleSidebar}
        />
      )}

      <header className="dashboard-header" ref={headerRef}>
        {/* LEFT */}
        <div className="header-left">
          <button className="menu-btn" onClick={onToggleSidebar}>
            <i className="fa fa-bars" />
          </button>

          <h6 className="header-title">{title}</h6>
        </div>

        {/* RIGHT */}
        <div className="header-right">

          {/* DASHBOARD SWITCH */}
          <div className="dropdown">
            <button
              className="hrm-btn"
              onClick={() =>
                setOpenMenu(openMenu === "switch" ? null : "switch")
              }
            >
              {isAdminDashboard ? "Admin" : "HRM / CRM"}
              <i className="fa fa-chevron-down" />
            </button>

            {openMenu === "switch" && (
              <ul className="dropdown-menu show">
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      navigate("/dashboard/hrmcrm");
                      setOpenMenu(null);
                    }}
                  >
                    HRM / CRM Dashboard
                  </button>
                </li>

                {user?.can_admin && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => {
                        navigate("/dashboard/admin");
                        setOpenMenu(null);
                      }}
                    >
                      Admin Dashboard
                    </button>
                  </li>
                )}
              </ul>
            )}
          </div>

          {/* NOTIFICATIONS */}
          <button className="notif-btn">
            <i className="fa fa-bell" />
            <span className="notif-badge">2</span>
          </button>

          {/* PROFILE */}
          <div className="dropdown">
            <button
              className="profile-btn"
              onClick={() =>
                setOpenMenu(openMenu === "profile" ? null : "profile")
              }
            >
              <div className="profile-avatar">{initials}</div>
              <i className="fa fa-chevron-down profile-caret" />
            </button>

            {openMenu === "profile" && (
              <ul className="dropdown-menu show profile-menu">
                <li className="profile-menu-header">
                  <strong>
                    {user?.first_name} {user?.last_name}
                  </strong>
                  <div className="text-muted small">
                    {user?.can_admin ? "Administrator" : "Staff"}
                  </div>
                </li>

                <li><hr className="dropdown-divider" /></li>

                <li>
                  <button className="dropdown-item">Profile</button>
                </li>

                <li>
                  <button
                    className="dropdown-item text-danger"
                    onClick={() => navigate("/logout")}
                  >
                    Logout
                  </button>
                </li>
              </ul>
            )}
          </div>
        </div>
      </header>
    </>
  );
}